import { HierarchicalMenu } from './HierarchicalMenu';

export type { TypeHierarchicalMenuProps } from './types';
export default HierarchicalMenu;
